import React, {useState,useEffect} from "react";
import './cookies.css'

import MaskBackground from "../maskBackground/maskBackground";
import imgCookie from "../../image/icon/cookie.webp"
import QBlack from "../../image/logo/QBlack.svg"
import bottomLine from "../../image/Menu/baseLine.webp"
import { FiChevronDown,FiChevronUp } from "react-icons/fi";


interface CookiesProps {
    preferences:boolean,
    intentGoMap: number;
    setIntentGoMap: React.Dispatch<React.SetStateAction<number>>;
    setShowCookies: React.Dispatch<React.SetStateAction<boolean>>;
    setPreferencesCookies: React.Dispatch<React.SetStateAction<boolean>>;
    setConnectionScreen: React.Dispatch<React.SetStateAction<boolean>>;
    setCookiesFromFooter: React.Dispatch<React.SetStateAction<boolean>>;
    cookiesFromFooter: boolean;
}

const Cookies:React.FC<CookiesProps> = ({preferences,intentGoMap,setIntentGoMap,setShowCookies,setPreferencesCookies,setConnectionScreen,setCookiesFromFooter,cookiesFromFooter}) => {
    const [editCookies,setEditCookies] = useState(preferences)
    const [acceptCookie,setAcceptCookie] = useState<boolean[]>([true,false,false,false,false])
    const [infoCookie,setInfoCookie] = useState<boolean[]>([false,false,false,false,false])
    
    useEffect(() => {
        const cookie = document.cookie.split('; ').find(row => row.startsWith('QUELRESTO_COOKIE='));
        
        if (cookie) {
          const cookieValue = cookie.split('=')[1];
          try {
            const decode = decodeURIComponent(cookieValue)
            const cookieData = JSON.parse(decode);
            setAcceptCookie([
              acceptCookie[0],
              cookieData['perform-analytics'] || false, 
              cookieData['preferences'] || false,
              cookieData['social-media'] || false,
              cookieData['measurement'] || false,
            ]);
          } catch (error) {
            console.error('Erreur lors du parsing du cookie:', error);
          }
        }
        return () => {
            setPreferencesCookies(false)
        }
      }, []);
    
    
    const updateInfocookie = (id:number) => {
            const prev = [...infoCookie]
            prev[id] = !prev[id]
            setInfoCookie(prev)
        }
    const updateAcceptcookie = (id:number) => {
        const prev = [...acceptCookie]
        prev[id] = !prev[id]
        setAcceptCookie(prev)
    }

    const finalCookie = (choose?:number) => {

        const sixMonths = 6 * 30 * 24 * 60 * 60;
        const expirationDate = new Date(Date.now() + sixMonths * 1000).toUTCString();

        const cookieData: Record<string, boolean | string> = {};
        cookieData['perform-analytics'] = choose !== undefined ? ( choose === 0 ? false : true ) : acceptCookie[1];
        cookieData['preferences'] = choose !== undefined ? ( choose === 0 ? false : true ) : acceptCookie[2];
        cookieData['social-media'] = choose !== undefined ? (choose === 0 ? false : true ) : acceptCookie[3];
        cookieData['measurement'] = choose !== undefined ? (choose === 0 ? false : true ) : acceptCookie[4];
        cookieData['version'] = '3'

        const existingScript = document.querySelector('script[src*="googletagmanager.com/gtag/js"]');
        const IS_PROD_FR = window.location.hostname.includes('quelresto.fr');
        const NEEDS_GTAG  = cookieData['perform-analytics'] || (cookieData['measurement'] && IS_PROD_FR);


        if (NEEDS_GTAG && !existingScript) {
            const inline = document.createElement('script');
       
            inline.id = 'gtag-init';
            inline.innerHTML = `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                

                gtag('consent', 'default', {
                    ad_storage: 'denied',
                    analytics_storage: 'denied',
                    ad_user_data: 'denied',
                    ad_personalization: 'denied'
                });

                gtag('js', new Date());
            `;
            document.head.appendChild(inline);
            const script = document.createElement('script');
            script.src = `https://www.googletagmanager.com/gtag/js?id=G-${process.env.REACT_APP_TAG_ANALYSE}`;
            script.async = true;
            document.head.appendChild(script);

        }
        if (NEEDS_GTAG && typeof window.gtag === 'function') {
            if (cookieData['perform-analytics']) {
                window.gtag('consent', 'update', { 'analytics_storage': 'granted' });
                window.gtag('config', `G-${process.env.REACT_APP_TAG_ANALYSE}`);
            }
            if (cookieData['measurement'] && IS_PROD_FR) {
                window.gtag('consent', 'update', {
                    ad_storage: 'granted',
                    ad_user_data: 'granted'
                });
                window.gtag('config', `${process.env.REACT_APP_TAG_ANALYSE_ADS}`);
            }
        }

        const domain = process.env.REACT_APP_TAG_ANALYSE === process.env.REACT_APP_TAG_ANALYSE_QR
        ? ".quelresto.fr"
        : ".quelresto.com";

        if (!cookieData['perform-analytics']) {
            document.cookie.split(";").forEach((cookie) => {
                const cookieName = cookie.split("=")[0].trim();
                if (cookieName.startsWith("_ga") || cookieName === "_gid") {
                    
                    document.cookie = `${cookieName}=; Max-Age=0; path=/; domain=${domain}; Secure; SameSite=Lax`;
                }
            });
        }
        if(!cookieData['perform-analytics'] && !cookieData['measurement'] && !cookieData['preferences'] && document.cookie.includes("g_state=")) {
            document.cookie = `g_state=; Max-Age=0; path=/; domain=${domain}; Secure; SameSite=Lax`;
        }

        if (!cookieData['measurement']) {
            document.cookie.split(";").forEach((cookie) => {
                const cookieName = cookie.split("=")[0].trim();
                if (cookieName.startsWith("_gcl")) {
                    
                    document.cookie = `${cookieName}=; Max-Age=0; path=/; domain=${domain}; Secure; SameSite=Lax`;
                }
            });
        }
        if(!cookieData['perform-analytics'] && !cookieData['measurement']) {
            if(existingScript) {
                existingScript.remove();
                const configScript = document.querySelector('script:not([src])');
                if (configScript?.innerHTML.includes("gtag")) {
                configScript.remove();
                }
            }
        }

        if (cookieData['perform-analytics'] && intentGoMap === 1) {
            setIntentGoMap(2)
        }else {
            setIntentGoMap(0)
        }

        const jsonString = encodeURIComponent(JSON.stringify(cookieData));
        document.cookie = `QUELRESTO_COOKIE=${jsonString}; expires=${expirationDate}; path=/; Secure; SameSite=Lax`;
        setAcceptCookie(prev => prev.map((elem, id) => id !== 0 ? false : elem));
        setInfoCookie([false,false,false,false,false])
        setShowCookies(false)
        setCookiesFromFooter(false)
    };
    
    return (
        <>
        <div className={`containerShowCookie primaryBack ${!editCookies && 'notEdit'}`} style={{zIndex:cookiesFromFooter ? 110 : 104}} >
            <div className={`topBar largeTitle ${editCookies && 'edit'}`}>
                <img className="icon1" src={imgCookie} loading="lazy" alt="cookie"/>
                <div>
                    {editCookies ? 'Gérer mes cookies' : 'Bienvenue sur QuelResto !'}
                    {!editCookies &&<img src={bottomLine} loading="lazy" alt="ligne"/>}
                </div>
                <img className="icon2" src={QBlack} loading="lazy" alt="logo"/>
            </div>
            <div className="mainCorp smallText">
                {!editCookies ? <>
                <p>{`Chez QuelResto, nous utilisons des cookies pour vous offrir une expérience optimale sur notre site. Ces cookies assurent le bon fonctionnement de nos services, personnalisent votre navigation et
                    nous aident à mieux comprendre vos attentes. Certains services tiers peuvent également déposer des cookies pour faciliter votre navigation et enrichir les fonctionnalités proposées.`}</p>
                <p>{`Nous accordons beaucoup d’importance à la transparence et à la protection de vos données personnelles. Vous gardez le contrôle total sur l’utilisation des cookies et pouvez modifier vos préférences à tout moment.`}</p>
                <p>{`Vos choix seront conservés pendant 6 mois et peuvent être modifiés à tout moment en cliquant sur « Gestion des cookies » en bas de chaque page.`}</p>
                <p>Pour plus d’informations, consultez notre <span onClick={() => window.open(`/PolitiqueCookies`, '_blank','noopener,noreferrer')} >Politique des cookies</span>.</p>

                </>
                :
                <> 
                    <p>Un cookie est un petit fichier texte déposé sur votre appareil lors de votre navigation. Il permet de reconnaître votre appareil, de mémoriser vos préférences
                    et de collecter des informations pour améliorer nos services.</p>
                    <p>Nous utilisons différents types de cookies pour garantir le bon fonctionnement du site, analyser ses performances et personnaliser votre expérience. Certains sont essentiels, tandis que d’autres nous aident à mieux comprendre
                    vos attentes pour adapter nos services. Vos choix seront conservés pendant 6 mois, et vous pouvez les modifier à tout moment en bas de chaque page.</p> 
                    <p>Pour plus d’informations consultez notre <span onClick={() => window.open(`/PolitiqueCookies`, '_blank','noopener,noreferrer')} >Politique des cookies</span>.</p>
                    
                    <div className="elem">
                        <div className="onglet lowOpacityHover pointer" onClick={()=> updateInfocookie(0)}>
                            <p className="smallTextBold">Cookies strictement nécessaires</p>
                            {infoCookie[0] ? <FiChevronUp size={20} className="chevron"/> : <FiChevronDown size={20} className="chevron"/>}
                        </div>
                        <p className="allActive" style={{color:'green'}}>Toujours activé</p>
                    </div>
                        
                    {infoCookie[0] && <div className="info">Ils garantissent le bon fonctionnement du site et la sécurité de votre navigation. Sans eux, certaines fonctionnalités essentielles, comme l’accès sécurisé ou la connexion, pourraient ne pas fonctionner correctement.</div>}

                    <div className="elem">
                        <div className="onglet lowOpacityHover pointer" onClick={()=> updateInfocookie(1)}>
                            <p className="smallTextBold">Cookies de performance et d’analyse</p>
                            {infoCookie[1] ? <FiChevronUp size={20} className="chevron"/> : <FiChevronDown size={20} className="chevron"/>}
                        </div>
                        <div className={`toggle-container ${acceptCookie[1] ? "on" : ""}`} onClick={() => updateAcceptcookie(1)}>
                            <div className="toggle-circle"></div>
                        </div>
                    </div>
                    {infoCookie[1] &&<div className="info">Ces cookies nous permettent d’analyser l’utilisation du site et d’améliorer ses performances. Ils collectent des données anonymes pour comprendre vos interactions avec nos services (Google Analytics, Google Maps, etc.).
                    </div>}
                    <div className="elem">
                        <div className="onglet lowOpacityHover pointer" onClick={()=> updateInfocookie(2)}>
                            <p className="smallTextBold">Cookies de personnalisation</p>
                            {infoCookie[2] ? <FiChevronUp size={20} className="chevron"/> : <FiChevronDown size={20} className="chevron"/>}
                        </div>
                        <div className={`toggle-container ${acceptCookie[2] ? "on" : ""}`} onClick={() => updateAcceptcookie(2)}>
                            <div className="toggle-circle"></div>
                        </div>
                    </div>
                    {infoCookie[2] &&<div className="info">Ils rendent votre expérience plus fluide en mémorisant vos préférences, comme la langue choisie ou les recommandations personnalisées de restaurants.</div>}
                    <div className="elem">
                        <div className="onglet lowOpacityHover pointer" onClick={()=> updateInfocookie(3)}>
                            <p className="smallTextBold">Cookies de réseaux sociaux</p>
                            {infoCookie[3] ? <FiChevronUp size={20} className="chevron"/> : <FiChevronDown size={20} className="chevron"/>}
                        </div>
                        <div className={`toggle-container ${acceptCookie[3] ? "on" : ""}`} onClick={() => updateAcceptcookie(3)}>
                            <div className="toggle-circle"></div>
                        </div>
                    </div>
                    {infoCookie[3] &&<div className="info">Ces cookies sont déposés par des plateformes externes comme Facebook et Instagram lorsque vous consultez ou interagissez avec des contenus intégrés sur QuelResto. Ils permettent d’afficher ces contenus directement sur le site et peuvent être utilisés par ces plateformes pour suivre votre navigation ou personnaliser leurs services et publicités.</div>}
                    <div className="elem">
                        <div className="onglet lowOpacityHover pointer" onClick={()=> updateInfocookie(4)}>
                            <p className="smallTextBold">Cookies de mesure et de publicité</p>
                            {infoCookie[4] ? <FiChevronUp size={20} className="chevron"/> : <FiChevronDown size={20} className="chevron"/>}
                        </div>
                        <div className={`toggle-container ${acceptCookie[4] ? "on" : ""}`} onClick={() => updateAcceptcookie(4)}>
                            <div className="toggle-circle"></div>
                        </div>
                    </div>
                    {infoCookie[4] &&<div className="info">Ces cookies sont utilisés pour mesurer l’efficacité de nos campagnes publicitaires (notamment via Google Ads) et analyser les actions réalisées après un clic sur une annonce. Ils nous aident à évaluer la performance de nos publicités et à améliorer leur diffusion.</div>}
                </>
                }
            </div>
            <div className="footBar">
                    {!editCookies ? <>
                    <p className="privacyLink XsmallText">
                        <span onClick={() => window.open(`/PolitiqueCookies`, '_blank','noopener,noreferrer')} > Politique des cookies</span>
                    </p>
                    <p className="smallWhiteButton smallTextBold" onClick={() => setEditCookies(true)}>Mes préférences</p>
                    <p className="smallWhiteButton smallTextBold" onClick={() => {finalCookie(0)}}>Tout refuser</p>
                    <p className="finalbutton smallGoldButton smallText" onClick={() => {finalCookie(1)}}>Tout accepter</p>
                    </>
                    :   
                    <>
                        <p className="privacyLink XsmallText">
                            <span onClick={() => window.open(`/PolitiqueCookies`, '_blank','noopener,noreferrer')} > Politique des cookies</span>
                        </p>
                        <p className="smallWhiteButton smallTextBold" onClick={() => {finalCookie(0)}}>Tout refuser</p>
                        <p className="smallWhiteButton smallTextBold" onClick={() => finalCookie()}>Valider mes préférences</p>
                        <p className="smallWhiteButton smallTextBold" onClick={() => {finalCookie(1)}}>Tout accepter</p>
                    </>
                }
            </div>
        </div>
        <MaskBackground zIndex={cookiesFromFooter ? 109 : 103} closeFunction={() => setConnectionScreen(false)}/>
        </>
    )
}
export default Cookies